import type { PaymentRepository, CreatePaymentIntentParams } from '@/domain/port/PaymentRepository';
import type { PaymentMethod } from '@/domain/model/PaymentMethod';
import type { PaymentIntent } from '@/domain/model/PaymentIntent';
import type { PaymentTransaction } from '@/domain/model/PaymentTransaction';
import type { SavedPaymentMethod } from '@/domain/model/SavedPaymentMethod';

export class PaymentService {
  private readonly paymentRepository: PaymentRepository;

  constructor(paymentRepository: PaymentRepository) {
    this.paymentRepository = paymentRepository;
  }

  getAvailableMethods(): Promise<PaymentMethod[]> {
    return this.paymentRepository.getAvailableMethods();
  }

  createPaymentIntent(params: CreatePaymentIntentParams): Promise<PaymentIntent> {
    return this.paymentRepository.createPaymentIntent(params);
  }

  confirmPayment(externalPaymentId: string): Promise<PaymentTransaction> {
    return this.paymentRepository.confirmPayment(externalPaymentId);
  }

  getPaymentHistory(): Promise<PaymentTransaction[]> {
    return this.paymentRepository.getPaymentHistory();
  }

  getSavedMethods(): Promise<SavedPaymentMethod[]> {
    return this.paymentRepository.getSavedMethods();
  }

  deleteMethod(id: string): Promise<void> {
    return this.paymentRepository.deleteMethod(id);
  }

  setDefaultMethod(id: string): Promise<SavedPaymentMethod> {
    return this.paymentRepository.setDefaultMethod(id);
  }
}
